// Design tokens, one set per brand. gpscare holds the pre-TLS-14 values verbatim
// (see tokens.test.js); tlscare follows the TLScare marketing site with the
// text/background pairings corrected to WCAG AA. Contrast ratios are on white
// unless noted.

import tlscareJson from "./tlscare.tokens.json";

const gpscare = {
  colors: {
    "primary": "#043c54",
    "primary-light": "#D9EDBE",
    "secondary": "#adc245",
    "accent": "#adc245",
    "gradient-brand": "#043c54",

    "text": "#053F57",
    "heading": "#053F57",
    "text-body": "#053F57",
    "text-muted": "#697A8D",

    "bg-color": "#E6E6E6",
    "surface": "#FFFFFF",
    "border": "rgba(0, 0, 0, 0.2)",
    "border-input": "rgba(0, 0, 0, 0.23)",

    "success-text": "#0F7A5A",
    "danger-text": "#B42318",
    "warning-text": "#8A5A00",

    "list": "#043c5416",
    "note": "#FFFF0026",

    "diary-completed": "#00FF0040",
    "diary-inprogressed": "#5BC0DE40",
    "diary-missed": "repeating-linear-gradient(-45deg, #FF000026, #FF000026 3px, #CCCCCC 3px, #CCCCCC 5px)",
    "diary-late-checkin": "#FFFF0040",

    "event-active": "#043C54",
    "event-cancelled": "#D9534F40",
    "event-completed": "#198754",
    "event-checked-in": "#5BC0DE",
    "event-missed": "repeating-linear-gradient(-45deg, #FF000080, #FF000080 3px, #CCCCCC 3px, #CCCCCC 5px)",
    "event-missed-calendar": "#FF000080",

    // Schedule grid lines, today tint and status chips (bg / text / left bar).
    // gpscare keeps the solid event colours it always used.
    "sched-line": "grey",
    "sched-today": "#043c5410",
    "chip-active-bg": "#043C54",
    "chip-active-fg": "#FFFFFF",
    "chip-active-bar": "#043C54",
    "chip-checked-in-bg": "#5BC0DE",
    "chip-checked-in-fg": "#FFFFFF",
    "chip-checked-in-bar": "#5BC0DE",
    "chip-completed-bg": "#198754",
    "chip-completed-fg": "#FFFFFF",
    "chip-completed-bar": "#198754",
    "chip-cancelled-bg": "#D9534F40",
    "chip-cancelled-fg": "#053F57",
    "chip-cancelled-bar": "#D9534F",
    "chip-missed-bg": "#FF000080",
    "chip-missed-fg": "#FFFFFF",
    "chip-missed-bar": "#FF0000",

    // Home KPI badges and chart defaults. gpscare keeps the bar colours the
    // analytics charts always used (primary at 19% fill, 1px primary border).
    "kpi-badge-bg": "#D9EDBE",
    "kpi-badge-fg": "#043c54",
    "chart-bar": "#043c5430",
    "chart-bar-border": "#043c54",
    "chart-grid": "rgba(0, 0, 0, 0.1)",
    "chart-tick": "#053F57",
  },
  radius: { card: 10, control: 10, small: 8, pill: 999, bar: 0 },
  shadow: {
    card: "0px 2px 0px 0px rgba(0, 0, 0, .2)",
    raised: "0px 2px 0px 0px rgba(0, 0, 0, .2)",
  },
  font: {
    family: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
  },
  // px sizes for the semantic text scale; "default" applies when none is given.
  type: {
    "default": 12,
    "heading-1": 44,
    "heading-2": 24,
    "heading-3": 20,
    "heading-4": 18,
    "heading-5": 16,
    "body-lg": 18,
    "body": 16,
    "body-sm": 12,
    "body-xs": 8,
  },
};

const tlscare = {
  colors: { ...gpscare.colors, ...tlscareJson.colors },
  radius: { ...gpscare.radius, ...tlscareJson.radius },
  shadow: { ...gpscare.shadow, ...tlscareJson.shadow },
  font: { family: tlscareJson.font.family },
  type: { ...gpscare.type, ...tlscareJson.type },
};

const tokenSets = { gpscare, tlscare };

export function resolveTokens(brandKey) {
  return tokenSets[brandKey] ?? tokenSets.gpscare;
}

export { gpscare as gpscareTokens, tlscare as tlscareTokens, tlscareJson as tlscareJsonTokens };
